<template>
  <section class="emmaus-wrap py-5">
    <div class="container">

      <!-- Titre -->
      <p class="emmaus-intro text-center mb-5">
        Révision, approfondissement théologique appliqué et ateliers de travail
      </p>

      <!-- Présentation -->
      <div class="info-box mb-5">
        <p>
          Le <strong>Parcours Disciples d’Emmaüs Sup</strong> est consacré à la
          révision et à l’approfondissement théologique appliqué, à partir des
          acquis des deux premières années et par des ateliers de travail.
        </p>
        <p>
          Le programme comporte <strong>trois axes majeurs</strong> :
          révision, étude de thèmes et mini-mémoire.
        </p>
      </div>

      <!-- Axes -->
      <div class="row g-4 mb-5">
        <div
          class="col-md-4"
          v-for="(axis, i) in axes"
          :key="i"
        >
          <div class="emmaus-card">
            <div class="emmaus-number">{{ i + 1 }}</div>
            <h5 class="axis-title">{{ axis.title }}</h5>
            <p class="axis-desc">{{ axis.description }}</p>
          </div>
        </div>
      </div>

      <!-- Révision -->
      <div class="section-box mb-5">
        <h4 class="section-subtitle mb-3">1. Révision</h4>
        <p>
          Chaque module enseigné durant les deux premières années bénéficie
          d’une ou deux heures de révision.
        </p>

        <ul class="list-inline">
          <li v-for="(m, i) in revisionModules" :key="i">
            {{ m }}
          </li>
        </ul>

        <p class="mt-3">
          Le professeur peut soit laisser une ou plusieurs personnes présenter un résumé du cours suivi de 15 mn, des questions en 15 mn ; et à la fin, il offre son résumé par rapport aux axes majeurs ;
          soit présenter directement son résumé suivi de questions.
        </p>
      </div>

      <!-- Étude des thèmes -->
      <div class="section-box mb-5">
        <h4 class="section-subtitle mb-3">2. Étude de thèmes</h4>

        <p>
          Sept thèmes sont étudiés en perspective pluridisciplinaire. L’enseignant se présente ici comme un véritable tuteur.
        </p>

        <div class="timeline">
          <div v-for="(s, i) in sessions" :key="i" class="timeline-item">
            <span class="timeline-dot"></span>
            <div>
              <strong>{{ s.title }}</strong>
              <p>{{ s.text }}</p>
            </div>
          </div>
        </div>

        <!-- Liste des thèmes -->
        <div class="row g-4 mt-4">
          <div
            class="col-md-6"
            v-for="(theme, i) in themes"
            :key="i"
          >
            <div class="theme-card">
              <h6>{{ i + 1 }}. {{ theme.title }}</h6>
              <p v-if="theme.subtitle">{{ theme.subtitle }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Mini-mémoire -->
      <div class="section-box mb-5">
        <h4 class="section-subtitle mb-3">3. Mini-mémoire</h4>
        <p>
          À la fin du parcours, le disciple dispose de
          <strong>3 mois</strong> pour rédiger un mini-mémoire
          de <strong>25 à 50 pages</strong>, sous la direction d’un encadreur. Le mémoire sera présenté selon des conditions bien définies.
        </p>
      </div>

      <!-- Organisation & Coût -->
      <div class="row g-4 mb-5">
        <div class="col-md-6">
          <div class="info-box">
            <h5>Organisation</h5>
            <p><strong>40 à 50 séances</strong> sur l’année</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="info-box">
            <h5>Coût</h5>
            <ul>
              Le coût de la 3 ème année s'élève à 80 000 FCFA
              <li>Inscription : <strong>5 000 FCFA</strong></li>
              <li>
                Frais de photocopies : <strong>5 000 FCFA</strong>
              </li>
              <li>
                Frais de Formation : <strong>70 000 FCFA</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Critères -->
      <div class="section-box">
        <h4 class="section-subtitle mb-3">Critères & Attestation</h4>
        <ul>
          <li>Le cours est ouvert aux disciples</li>
          <li>L’inscription est possible pour les Habitués et Auditeurs qui le souhaitent, sur demande. </li>
          <li>
            Les disciples reçoivent une <strong>attestation à la fin de formation-icon-wrapper</strong>
          </li>
          <li>
            Les habitués et auditeurs reçoivent un
            <strong>certificat de fin de formation</strong>
            (sans obligation de mémoire)
          </li>
        </ul>
      </div>
      <br><br><br>
        <div class="text-center">
            <a href="/FicheInscriptiontroisième année.pdf" 
            download="FicheInscriptiontroisième année.pdf"
            class="btn-download me-3">
            Télécharger la fiche d'inscription
            </a>
        </div>

    </div>
  </section>
</template>
<script lang="ts">
export default {
  name: "ParcoursEmmausSup",
  data() {
    return {
      axes: [
        {
          title: "Révision",
          description: "Relecture structurée des acquis des deux premières années."
        },
        {
          title: "Étude de thèmes",
          description: "Approfondissement théologique en perspective pluridisciplinaire."
        },
        {
          title: "Mini-mémoire",
          description: "Travail personnel de recherche sous la direction d’un enseignant."
        }
      ],

      revisionModules: [
        "Bible",
        "Théologie",
        "Histoire",
        "Liturgie",
        "Spiritualité",
        "Morale"
      ],

      sessions: [
        {
          title: "Séance 1",
          text: "Présentation du thème sous différents axes (biblique, patristique, théologique, historique, liturgique, éthique, etc.), assurés par divers enseignants. De cette présentation, sont dégagés des sous-thèmes pour des travaux de recherche en groupes. Les travaux de recherche doivent être des études de cas concret."
        },
        {
          title: "Séance 2",
          text: "Exposé par 2 ou 3 groupes au moins. Les groupes d’exposés seront composés de 4 ou 5 personnes au maximum."
        },
        {
          title: "Séance 3",
          text: "Débat général et synthèse du chargé du thème."
        }
      ],

      themes: [
        { title: "Dieu et l’homme", subtitle: "La grâce et la collaboration à la grâce" },
        { title: "Entre l’idéal et la réalité : Le chrétien dans la société. ", subtitle: "Analyse de quelques cas éthiques / La sainteté dans le mariage" },
        { title: "La mystique chrétienne", subtitle: "Les anges : nature et mission / Le discernement des esprits / Exorcisme / La souffrance : approches chrétiennes. " },
        { title: "Église, Monde et Société", subtitle: "Engagement chrétien" },
        { title: "L’homme et l’au-delà", subtitle: "La mort et l’après-vie certitudes et problèmes" },
        { title: "À l’école d’un théologien", subtitle: "Culture, colonisation, indépendance" },
        { title: "Etude de Personnages bibliques", subtitle: "Job et Tobie ; Jean et Pierre, Paul Le symbole des chiffres et la gémantrie" },
        { title: "Agir en bon chrétien dans la cité", subtitle: "Critères pour un bon discernement" },
        { title: "Méthodologie théologique" }
      ]
    }
  }
}
</script>
<style scoped>
.emmaus-wrap {
  background: #f8f9fa;
}

.emmaus-title {
  color: #0b1b3f;
  font-weight: 800;
}

.emmaus-intro {
  color: #6c757d;
}

.section-subtitle {
  color: #0b1b3f;
  font-weight: 700;
}

.emmaus-card {
  background: white;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
  text-align: center;
}

.emmaus-number {
  width: 45px;
  height: 45px;
  background: #ffc107;
  color: #0b1b3f;
  font-weight: 800;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.axis-title {
  color: #0b1b3f;
  font-weight: 700;
}

.section-box {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

.list-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0;
}

.list-inline li {
  list-style: none;
  background: #0b1b3f;
  color: white;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.85rem;
}

.theme-card {
  background: #f8f9fa;
  border-left: 5px solid #ffc107;
  padding: 18px;
  border-radius: 12px;
}

.info-box {
  background: white;
  padding: 22px;
  border-radius: 14px;
  border-left: 6px solid #0b1b3f;
}

.btn-download {
  background: #ffc107;
  color: #0b1b3f;
  font-weight: 700;
  padding: 12px 26px;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-download:hover {
  background: #e0a800;
  transform: translateY(-2px);
}
</style>
